export default __webpack_public_path__ + "static/media/icon-medical-leave-pm.4454f036.svg";